import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TermAndConditionEdit } from '../model/term-and-condition';
import { merge } from 'lodash';
import { UntypedFormBuilder, UntypedFormControl, ValidationErrors, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { TermAndConditionValidators } from 'src/app/core/validators/term-and-condition.validators';
import { Base64Util } from 'src/app/core/utility/base64-util';

@Component({
  selector: 'app-term-and-condition-edit',
  templateUrl: './term-and-condition-edit.component.html',
  styleUrls: ['./term-and-condition-edit.component.scss']
})
export class TermAndConditionEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<TermAndConditionEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;

  private termAndConditionEdit: TermAndConditionEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private termAndConditionValidators: TermAndConditionValidators)
  { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get content(): UntypedFormControl
  {
    return this.editForm.get('content');
  }

  public get active(): UntypedFormControl
  {
    return this.editForm.get('active');
  }

  @Input() public set model(termAndConditionEdit: TermAndConditionEdit)
  {
    this.initModel(termAndConditionEdit);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();

    const objectToPersist = merge(this.termAndConditionEdit, this.editForm.value);
    const content = Base64Util.encodeUnicode(this.content.value);
    objectToPersist.content = content;

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(termAndCondition: TermAndConditionEdit)
  {
    if (termAndCondition === undefined)
    {
      return;
    }
    // Set the current name used for name async validators
    const previousCategoryName = this.isNew ? '' : termAndCondition.name;

    if (termAndCondition.content !== null)
    {
      const content = Base64Util.decodeUnicode(termAndCondition.content);
      termAndCondition.content = content;
    }

    // Set form
    this.editForm = this.fb.group({
      id: [termAndCondition.id],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.termAndConditionValidators
              .validateTermAndConditionNameUnique(this.editForm.get('name'), previousCategoryName)
        }
      ],
      content: [termAndCondition.content, Validators.required],
      active: { value: termAndCondition.active, disabled: false }
    });

    this.termAndConditionEdit = termAndCondition;
    this.name.setValue(termAndCondition.name);  // This is a work around to fix asyncValidators
    this.editFormActive = true;
  }
}
